import '@bifeai/ui/globals.css';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, ToastProvider } from '@bifeai/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { isApiError } from './lib/api';
import { installGlobalErrorReporting, reportClientError } from './lib/report';
import { router } from './router';

installGlobalErrorReporting();

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (isApiError(error, 'UNAUTHENTICATED')) {
        if (query.queryKey[0] !== 'me') void queryClient.invalidateQueries({ queryKey: ['me'] });
      } else if (!isApiError(error)) reportClientError(error);
    },
  }),
  defaultOptions: {
    queries: {
      retry: (count, error) => !isApiError(error) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Falta el elemento #root');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
